import React, { useState, useEffect, useContext } from 'react';
import {
  makeStyles,
  Grid,
  Typography,
  Divider,
  Button,
  Container,
  Fade,
  MenuItem,
  Select,
  CircularProgress
} from '@material-ui/core';
import { isMobileOnly } from 'react-device-detect';
import { Context as AuthContext } from '../../context/AuthContext';
import { Context as ArticleContext } from '../../context/ArticleContext';
import CustomModal from '../../components/CustomModal';

const DeleteArticle = ({ history }) => {
  const [selectedArticleId, setSelectedArticleId] = useState(null);
  const [modalText, setModalText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    state: { token },
    tryLocalSignin
  } = useContext(AuthContext);
  const {
    fetchArticles,
    deleteArticle,
    state: { articles }
  } = useContext(ArticleContext);

  const classes = useStyles();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await fetchArticles();
      setLoading(false);
    }

    tryLocalSignin(history, '/delete_article');
    fetchData();
  }, []);

  const handleSubmit = async () => {
    setLoading(true);

    const res = await deleteArticle(selectedArticleId);

    if (res.error) {
      setModalText('There is a problem in deleting the Article!');
    } else {
      setModalText('Article deleted successfully');
      setSelectedArticleId(null);
      fetchArticles();
    }

    setShowConfirmButton(false);
    setModalVisible(true);
    setLoading(false);
  };

  if (!token) {
    return null;
  }

  return (
    <div>
      <Container style={{ marginTop: '1%' }}>
        {loading && (
          <CircularProgress
            style={{
              display: 'flex',
              position: 'absolute',
              alignSelf: 'center',
              top: '50%',
              left: '50%'
            }}
          />
        )}
        <Fade timeout={1000} in={true}>
          <div>
            <Typography className={classes.title}>Delete Article</Typography>
            <Divider />
            <Grid
              className={
                isMobileOnly ? classes.mobileContainer : classes.container
              }
              container
            >
              <Grid xs={12}>
                <Typography className={classes.chooseText}>
                  Choose Article
                </Typography>
                <Select
                  placeholder="Choose category"
                  variant="outlined"
                  className={classes.selectCategory}
                  onChange={async event => {
                    setSelectedArticleId(event.target.value);
                  }}
                >
                  {articles.map(article => {
                    return (
                      <MenuItem value={article._id}>
                        {article.englishTitle}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
            </Grid>
            <Button
              variant="contained"
              color="secondary"
              className={classes.submitButton}
              onClick={() => {
                if (!selectedArticleId) {
                  return;
                }
                setModalText('Do you want to submit this?');
                setShowConfirmButton(true);
                setModalVisible(true);
              }}
            >
              Submit
            </Button>
            <CustomModal
              title="Warning!"
              content={modalText}
              visible={modalVisible}
              onCancel={() => setModalVisible(false)}
              onConfirm={handleSubmit}
              showConfirmButton={showConfirmButton}
              loading={loading}
            />
          </div>
        </Fade>
      </Container>
    </div>
  );
};

const useStyles = makeStyles({
  title: {
    fontSize: '1.6em'
  },
  container: {
    marginTop: '2%'
  },
  mobileContainer: {
    marginTop: '5%'
  },
  chooseText: {
    fontSize: '1.3em',
    marginBottom: '1%'
  },
  selectCategory: {
    width: isMobileOnly ? '85%' : '50%'
    //marginBottom: isMobileOnly ? '5%' : 0
  },
  uploadButton: {
    marginTop: '5%'
  },
  submitButton: {
    float: 'right',
    width: isMobileOnly ? '35%' : '10%',
    marginTop: isMobileOnly ? '5%' : 0,
    marginBottom: '2%'
  }
});

export default DeleteArticle;
